import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { configurationManagement } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { IMenuItem } from '@components/common/SideBar/interfaces';

import { TVendorsValues } from '@enums/common';

export const useVendorDrivenFeatureAvailability = () => {
	const { selectedVendor, vendorDrivenFeatures } = useAppSelector(configurationManagement);
	const { pathname } = useLocation();

	const [currentFeatureRoute, setCurrentFeatureRoute] = useState<IMenuItem | null>();

	useEffect(() => {
		setCurrentFeatureRoute(vendorDrivenFeatures.find(feature => feature.route === pathname));
	}, [pathname, vendorDrivenFeatures]);

	return (
		!currentFeatureRoute?.vendors?.length ||
		currentFeatureRoute.vendors.includes(selectedVendor?.value as TVendorsValues)
	);

};
